"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonPaginationDots = void 0;
const React = require("react");
const constants_1 = require("../../utils/constants");
const BronsonPaginationDots = (props) => {
    const bound = 5;
    const [total, setTotal] = React.useState(props.config.totalPages);
    const [currentPage, setCurrentPage] = React.useState(props.config.currentPage || constants_1.one);
    const [upperPageBound, setUpperPageBound] = React.useState(bound);
    const [lowerPageBound, setLowerPageBound] = React.useState(constants_1.zero);
    const [prevBtnDisabled, setPrevBtnDisabled] = React.useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = React.useState(true);
    const [isClickedIncrement, setIsClickedIncrement] = React.useState(false);
    const [isClickedDecrement, setIsClickedDecrement] = React.useState(false);
    const [pageBound] = React.useState(bound);
    React.useEffect(() => {
        const { totalPages } = props.config;
        const newCurrentPage = props.config.currentPage || constants_1.one;
        const div = Math.floor(newCurrentPage / pageBound);
        const upper = pageBound * (newCurrentPage % pageBound === constants_1.zero ? div : div + constants_1.one);
        setTotal(totalPages);
        setCurrentPage(newCurrentPage);
        setUpperPageBound(upper);
        setLowerPageBound(upper - pageBound);
        setPrevBtnDisabled(newCurrentPage <= constants_1.one);
        setNextBtnDisabled(newCurrentPage >= totalPages);
    }, [props.config.totalPages]);
    React.useEffect(() => {
        const { totalPages } = props.config;
        const currentPag = props.config.currentPage;
        if (currentPag === constants_1.one) {
            setUpperPageBound(bound);
            setLowerPageBound(constants_1.zero);
            setPrevBtnDisabled(true);
            setNextBtnDisabled(currentPag >= totalPages);
            setIsClickedIncrement(false);
            setIsClickedDecrement(false);
            setCurrentPage(currentPag);
        }
    }, [props.config.currentPage]);
    const fixedPages = {
        fontWeight: 'bold',
    };
    const setPrevAndNextBtn = (listId) => {
        const totalPage = total;
        setNextBtnDisabled(true);
        setPrevBtnDisabled(true);
        if (totalPage !== constants_1.one) {
            if (totalPage === listId) {
                setPrevBtnDisabled(false);
            }
            else if (listId === constants_1.one) {
                setNextBtnDisabled(false);
            }
            else {
                setPrevBtnDisabled(false);
                setNextBtnDisabled(false);
            }
        }
    };
    const handleClick = (event) => {
        event.preventDefault();
        const listId = Number(event.target.id);
        setCurrentPage(listId);
        setPrevAndNextBtn(listId);
        setIsClickedDecrement(false);
        setIsClickedIncrement(false);
        props.config.onPageChange(listId);
    };
    const handleFirstPage = (event) => {
        event.preventDefault();
        setCurrentPage(constants_1.one);
        setUpperPageBound(pageBound);
        setLowerPageBound(constants_1.zero);
        setNextBtnDisabled(false);
        setPrevBtnDisabled(true);
        setIsClickedDecrement(false);
        setIsClickedIncrement(false);
        props.config.onPageChange(constants_1.one);
    };
    const handleLastPage = (event) => {
        event.preventDefault();
        setCurrentPage(total);
        setUpperPageBound(total);
        setLowerPageBound(total - pageBound);
        setNextBtnDisabled(true);
        setPrevBtnDisabled(false);
        setIsClickedDecrement(false);
        setIsClickedIncrement(false);
        props.config.onPageChange(total);
    };
    const btnIncrementClick = (event) => {
        event.preventDefault();
        setUpperPageBound(upperPageBound + pageBound);
        setLowerPageBound(lowerPageBound + pageBound);
        const listId = upperPageBound + constants_1.one;
        setCurrentPage(listId);
        setPrevAndNextBtn(listId);
        setIsClickedIncrement(true);
        setIsClickedDecrement(false);
        props.config.onPageChange(listId);
    };
    const btnDecrementClick = (event) => {
        event.preventDefault();
        setUpperPageBound(upperPageBound - pageBound);
        setLowerPageBound(lowerPageBound - pageBound);
        const listId = upperPageBound - pageBound;
        setCurrentPage(listId);
        setPrevAndNextBtn(listId);
        setIsClickedIncrement(false);
        setIsClickedDecrement(true);
        props.config.onPageChange(listId);
    };
    const btnPrevClick = (event) => {
        event.preventDefault();
        if ((currentPage - constants_1.one) % pageBound === constants_1.zero) {
            setUpperPageBound(upperPageBound - pageBound);
            setLowerPageBound(lowerPageBound - pageBound);
        }
        const listId = currentPage - constants_1.one;
        setCurrentPage(listId);
        setPrevAndNextBtn(listId);
        setIsClickedDecrement(false);
        setIsClickedIncrement(false);
        props.config.onPageChange(listId);
    };
    const btnNextClick = (event) => {
        event.preventDefault();
        if (currentPage + constants_1.one > upperPageBound) {
            setUpperPageBound(upperPageBound + pageBound);
            setLowerPageBound(lowerPageBound + pageBound);
        }
        const listId = currentPage + constants_1.one;
        setCurrentPage(listId);
        setPrevAndNextBtn(listId);
        setIsClickedDecrement(false);
        setIsClickedIncrement(false);
        props.config.onPageChange(listId);
    };
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(total); i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = () => {
        return pageNumbers.map((number) => {
            if (number === constants_1.one && currentPage === constants_1.one) {
                return (React.createElement("li", { key: number, className: 'c-pagination__item active' },
                    React.createElement("a", { href: '#', className: 'c-pagination__link is-active', id: `${number}`, onClick: handleClick }, number)));
            }
            else if (number < upperPageBound + constants_1.one &&
                number > lowerPageBound) {
                return (React.createElement("li", { className: 'c-pagination__item', key: number, id: `${number}` },
                    React.createElement("a", { href: '#', className: `c-pagination__link ${currentPage === number ? 'is-active' : ''}`, id: `${number}`, onClick: handleClick }, number)));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        });
    };
    const pageIncrementBtn = () => {
        if (pageNumbers.length > upperPageBound) {
            return (React.createElement(React.Fragment, null,
                React.createElement("li", { className: 'c-pagination__item' },
                    React.createElement("a", { id: 'increment-dots', href: '#', className: `c-pagination__link ${isClickedIncrement
                            ? 'u-text-brand u-bg-pale'
                            : ''}`, onClick: btnIncrementClick }, "...")),
                React.createElement("li", { key: constants_1.one, className: 'c-pagination__item active' },
                    React.createElement("a", { href: '#', className: 'c-pagination__link', id: 'lastPage', onClick: handleLastPage, style: fixedPages }, total))));
        }
        return React.createElement(React.Fragment, null);
    };
    const pageDecrementBtn = () => {
        if (lowerPageBound >= constants_1.one) {
            return (React.createElement(React.Fragment, null,
                React.createElement("li", { key: constants_1.one, className: 'c-pagination__item active' },
                    React.createElement("a", { href: '#', className: 'c-pagination__link', id: 'fistPage', onClick: handleFirstPage, style: fixedPages }, "1")),
                React.createElement("li", { className: 'c-pagination__item' },
                    React.createElement("a", { id: 'decrement-dots', className: `c-pagination__link  ${isClickedDecrement
                            ? 'u-text-brand u-bg-pale'
                            : ''}`, href: '#', onClick: btnDecrementClick }, "..."))));
        }
        return React.createElement(React.Fragment, null);
    };
    const renderPrevBtn = () => {
        if (prevBtnDisabled === true) {
            return (React.createElement("li", { className: 'c-pagination__item', id: 'btnPrev' },
                React.createElement("span", { className: 'c-pagination__link  c-pagination__link--stepper-prev u-text-brand is-disabled' },
                    React.createElement("span", { className: 'u-visually-hidden' }))));
        }
        else {
            return (React.createElement("li", { className: 'c-pagination__item', id: 'btnPrev', onClick: btnPrevClick },
                React.createElement("span", { className: 'c-pagination__link  c-pagination__link--stepper-prev' },
                    React.createElement("span", { className: 'u-visually-hidden' }))));
        }
    };
    const renderNextBtn = () => {
        if (nextBtnDisabled === true || total <= constants_1.one) {
            return (React.createElement("li", { className: 'c-pagination__item' },
                React.createElement("span", { id: 'btnNext', className: 'c-pagination__link c-pagination__link--stepper-next  u-text-brand is-disabled ' },
                    React.createElement("span", { className: 'u-visually-hidden' }))));
        }
        else {
            return (React.createElement("li", { className: 'c-pagination__item' },
                React.createElement("span", { id: 'btnNext', className: 'c-pagination__link  c-pagination__link--stepper-next', onClick: btnNextClick, title: 'next page' },
                    React.createElement("span", { className: 'u-visually-hidden' }))));
        }
    };
    return (React.createElement("nav", { className: 'c-pagination', "aria-label": 'Pagination' },
        React.createElement("ul", { className: 'c-pagination__list', style: props.config.additionalStylesForNav || {} },
            renderPrevBtn(),
            pageDecrementBtn(),
            renderPageNumbers(),
            pageIncrementBtn(),
            renderNextBtn())));
};
exports.BronsonPaginationDots = BronsonPaginationDots;
